import React from "react";
//#region types
import { AuthHelper } from "utils/helpers";
//#endregion
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region components
import SelectCompany from "components/layout/selectCompany";
import { LoginContainer } from "components/login";
import { EULAView } from "components/eula";
//#endregion

const GenericCompanyRoute: React.FC = () => {
  const { isAuthenticated } = useSelector((store: AppState) => ({
    isAuthenticated: store.auth.isAuthorized,
  }));

  const showEULA = useSelector((store: AppState) => store.auth.loggedInUser.unsignedEula);

  return AuthHelper.authenticate() || isAuthenticated ? (
    showEULA ? (
      <EULAView />
    ) : (
      <SelectCompany />
    )
  ) : (
    <LoginContainer />
  );
};

export default GenericCompanyRoute;
